(function(app) {

    app.provider("externalArcContractReportApi",
    [
        function() {
            this.$get = [
                "externalsApiGateway", function(externalsApiGateway) {
                    var service = {};

                    service.getUserContracts = function(userId) {
                        return externalsApiGateway.getArray("/Users/" + userId + "/ArcContracts");
                    };

                    service.getContractDetail = function(userId, contractId) {
                        return externalsApiGateway.get("/Users/" + userId + "/ArcContracts/" + contractId);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app);